export default __webpack_public_path__ + "static/media/BM.08a47fcf.svg";